import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://boyfalniwzeqalgkkfdu.supabase.co";
const supabaseAnonKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJveWZhbG5pd3plcWFsZ2trZmR1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzkyMTQzMTAsImV4cCI6MjA5NDc5MDMxMH0.tZhOuie8pFWxb2Nd687fNetuukfK2dbFQwT9qTmA7bk";

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
